import { connect } from "react-redux";
import IaAgentComponent from "../../Components/IaAgent/IaAgentComponent";
import { setIaAgents } from "../../Redux/Actions/IaAgentActions";

const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    st_IaAgents: state.reducer.IA_AGENTS,
    SCOPES: state.reducer.SCOPES_NAMES,
    QUEUES: state.reducer.QUEUES,
});

const mapDispatchToProps = (dispatch) => ({
    setIaAgents: (IA_AGENTS) => dispatch(setIaAgents(IA_AGENTS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IaAgentComponent);
